<div class="edit-cell-template-area">
  <dx-text-box
    class="edit-cell-input"
    [value]="cellInfo?.value"
    (onValueChanged)="textValueChange($event, cellInfo)"
    [readOnly]="textBoxReadOnly"
  >
    <dxi-button *ngIf="showClearButtonTxtBox"
                name="today"
                location="after"
                [options]="clearButtonOpt"
    ></dxi-button>
  </dx-text-box>
  <dk-ctl-row-edit-search-popup class="drow-down-area"
                                [controlName]="controlName"
                                [filterArr]="filterArr"
                                [key]="key"
                                [startsWithFilterColumn]="startsWithFilterColumn"
                                [startsWithFilterColumnValue]="startsWithFilterColumnValue"
                                (closePopUp)="closePopup($event)"
                                [cellValue]="cellInfo?.value"
                                [dataField]="cellInfo?.column?.dataField"
                                [dropDownHeight]="dropDownHeight"
                                [dropDownWidth]="dropDownWidth"
                                [cellInfo]="cellInfo"
                                [selectedValueDispName]="selectedValueDispName"

  ></dk-ctl-row-edit-search-popup>

</div>
